import reportTypes from './ReportsTypes';

/* eslint-disable import/prefer-default-export */

/**
 * Report status options (NEW SCHEMA)
 * Replaces old active/inactive with draft/published/archived/scheduled
 */
export const reportStatusOptions = intl => {
  const options = [
    {
      label: intl.formatMessage({
        id: 'ui-reports.saveNewReportForm.reportStatusField.options.draft',
        defaultMessage: 'Draft'
      }),
      value: 'draft'
    },
    {
      label: intl.formatMessage({
        id: 'ui-reports.saveNewReportForm.reportStatusField.options.published',
        defaultMessage: 'Published'
      }),
      value: 'published'
    },
    {
      label: intl.formatMessage({
        id: 'ui-reports.saveNewReportForm.reportStatusField.options.archived',
        defaultMessage: 'Archived'
      }),
      value: 'archived'
    },
    {
      label: intl.formatMessage({
        id: 'ui-reports.saveNewReportForm.reportStatusField.options.scheduled',
        defaultMessage: 'Scheduled'
      }),
      value: 'scheduled'
    }
  ];
  return options;
};

/**
 * Report visibility options (NEW SCHEMA)
 * Replaces old privacyType with permissions.visibility
 */
export const reportVisibilityOptions = intl => {
  const options = [
    {
      label: intl.formatMessage({
        id: 'ui-reports.saveNewReportForm.reportVisibilityField.options.public',
        defaultMessage: 'Public'
      }),
      value: 'public'
    },
    {
      label: intl.formatMessage({
        id: 'ui-reports.saveNewReportForm.reportVisibilityField.options.private',
        defaultMessage: 'Private'
      }),
      value: 'private'
    },
    {
      label: intl.formatMessage({
        id: 'ui-reports.saveNewReportForm.reportVisibilityField.options.restricted',
        defaultMessage: 'Restricted'
      }),
      value: 'restricted'
    }
  ];
  return options;
};

/**
 * DEPRECATED: Use reportVisibilityOptions instead
 * Kept for backward compatibility
 */
export const reportPrivacyOptions = intl => {
  return reportVisibilityOptions(intl).filter(opt => opt.value !== 'restricted');
};

/**
 * Dashboard status options
 */
export const dashboardStatusOptions = intl => [
  {
    label: intl.formatMessage({ id: 'ui-reports.dashboard.status.draft', defaultMessage: 'Draft' }),
    value: 'draft',
  },
  {
    label: intl.formatMessage({ id: 'ui-reports.dashboard.status.published', defaultMessage: 'Published' }),
    value: 'published',
  },
  {
    label: intl.formatMessage({ id: 'ui-reports.dashboard.status.archived', defaultMessage: 'Archived' }),
    value: 'archived',
  },
];

/**
 * Dashboard visibility options
 */
export const dashboardVisibilityOptions = intl => [
  {
    label: intl.formatMessage({ id: 'ui-reports.dashboard.visibility.public', defaultMessage: 'Public' }),
    value: 'public',
  },
  {
    label: intl.formatMessage({ id: 'ui-reports.dashboard.visibility.private', defaultMessage: 'Private' }),
    value: 'private',
  },
  {
    label: intl.formatMessage({ id: 'ui-reports.dashboard.visibility.shared', defaultMessage: 'Shared' }),
    value: 'shared',
  },
];

/**
 * Dashboard theme options
 */
export const dashboardThemeOptions = intl => [
  {
    label: intl.formatMessage({ id: 'ui-reports.dashboard.theme.light', defaultMessage: 'Light' }),
    value: 'light',
  },
  {
    label: intl.formatMessage({ id: 'ui-reports.dashboard.theme.dark', defaultMessage: 'Dark' }),
    value: 'dark',
  },
  {
    label: intl.formatMessage({ id: 'ui-reports.dashboard.theme.auto', defaultMessage: 'Auto' }),
    value: 'auto',
  },
];

export const reportTypesOptions = intl => {
  return reportTypes.map(report => ({
    label: intl.formatMessage({
      id: `ui-reports.reportTypes.label.${report.value}`,
      defaultMessage: report.name
    }),
    value: report.value
  }));
};
